import { appliesWhenValues } from '@/common/components/ConditionsEditor/constants'

export const productsAppliesWhenMenuItems = [
  { value: appliesWhenValues.all, label: 'Todos los productos coinciden' },
  { value: appliesWhenValues.atLeastOne, label: 'Al menos un producto coincide' },
  { value: appliesWhenValues.none, label: 'Ningún producto coincide' },
]
